export const MY_LIST_ICONS = {
  MY_LIST_ICON_BOOKED: { name: 'ListAdded', type: ' icon' },
  MY_LIST_ICON_UNBOOKED: { name: 'ListAdd', type: 'icon' },
};
